import { COUNTRY_NETHERLANDS, COUNTRY_BELGIUM } from "../../helpers/consts";

export class ThankYouStep {
    /**
     * Component that handles the thank you step.
     * @constructor
     * @param {Object} options
     * @param {Store} options.store
     * @param {string} options.id - Step id string
     */
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.translations = options.translations;
        this.isValid = false;
        this.id = options.id;
        this.$support = document.querySelector('.support');
        this.$visual = document.querySelector('.thank-you-visual');
        this.$footerNav = document.querySelector('.footer__nav');
        this.$stepFooter = document.querySelector(`#wizard_${this.id} .step__footer`);
        this.$heading = document.querySelector(`#wizard_${this.id} h4`);
        this.createStep();
        this.update();
        this.store.subscribe(this.update.bind(this));
    }

    createStep() {
        const $container = document.createElement('div');
        const $exactOnlineLink = document.createElement('a');
        const country = this.state.formFields.find(field => field.id === 'country' ).value;
        let exactOnlineUrl = `https://start.exactonline.com/`;

        switch (country) {
        case COUNTRY_NETHERLANDS:
            exactOnlineUrl = `https://start.exactonline.nl/`;
            break;
        case COUNTRY_BELGIUM:
            exactOnlineUrl = `https://start.exactonline.be/`;
            break;
        default:
            break;
        }

        this.$heading.innerHTML = `${this.translations.thank_you_title ? this.translations.thank_you_title : 'Bedankt voor het creëren van je account'}`;
        $exactOnlineLink.href = (this.translations.thank_you_button_link && this.translations.thank_you_button_link !== "") ? this.translations.thank_you_button_link : exactOnlineUrl;

        $exactOnlineLink.id = 'thankyou-cta';
        $exactOnlineLink.classList.add('btn', 'btn--inline-block');
        $exactOnlineLink.innerHTML = `<span class="icon--before icon--arrow-right">${this.translations.thank_you_button ? this.translations.thank_you_button : 'Log in op Exact Online'}</span>`;

        this.$thankYouText = document.createElement('div');

        this.setThankYouText();

        $container.classList.add('container--boxed');
        $container.appendChild(this.$thankYouText);
        if(this.translations.thank_you_button_hide !== '1') {
            this.$stepFooter.appendChild($exactOnlineLink);
        }

        this.$el = $container;
    }

    getCurrentStep() {
        this.state = this.store.getState();
        const current = this.state.steps.find(step => step.current === true);
        return current;
    }

    setThankYouText() {
        this.$thankYouText.innerHTML = this.translations.thank_you_rte ? this.translations.thank_you_rte : `<p>Fijn dat je voor Exact Online hebt gekozen. We hebben je een bevestigingsmail gestuurd. Wil je op de link in de mail klikken? Daarna log je makkelijk in met je e-mailadres en wachtwoord.</p>
        <p>Veel succes met Exact Online!</p>
        <p><strong>Met vriendelijke groet,<br/>Het Exact Online team</strong></p>`;
    }

    showLastStepElements() {
        if (this.$visual) {
            this.$visual.classList.remove('visually-hidden');
        }

        if (this.$footerNav) {
            this.$footerNav.classList.remove('visually-hidden');
        }

        if (this.$stepFooter && this.$support) {
            this.$stepFooter.appendChild(this.$support);
        }
    }

    render() {
        return this.$el;
    }

    update() {
        const current = this.getCurrentStep();

        if(current.hidden) {
            this.showLastStepElements();
        }

        this.setThankYouText();
        this.state = this.store.getState();
    }
}

export default ThankYouStep;
